import { EntityModel } from '@/interfaces'
import {
  ALL_ACCOMMODATIONS_QUERY,
  CREATE_ACCOMMODATION_MUTATION,
  DELETE_ACCOMMODATION_MUTATION,
  FORCE_DELETE_ACCOMMODATION_MUTATION,
  SINGLE_ACCOMMODATION_QUERY,
  UPDATE_ACCOMMODATION_MUTATION,
} from './graphql'
import accommodationCapacitySettingsEntity from '@/entities/accommodationCapacitySettings/entity'
import ratioAccommodationAddonEntity from '@/entities/ratioAccommodationAddon/entity'

const ratioAccommodationModel: EntityModel = {
  name: 'accommodation',
  namePlural: 'accommodations',
  uniqueName: 'ratioAccommodation',
  uniqueNamePlural: 'ratioAccommodations',
  path: 'travel/pricing/adaptors/ratio/accommodation',
  baseUrl: '/travel/pricing/adaptors/ratio/accommodations',
  translationPrefix: 'entities:ratioAccommodation.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_ACCOMMODATIONS_QUERY,
    getSingle: SINGLE_ACCOMMODATION_QUERY,
    create: CREATE_ACCOMMODATION_MUTATION,
    update: UPDATE_ACCOMMODATION_MUTATION,
    delete: DELETE_ACCOMMODATION_MUTATION,
    forceDelete: FORCE_DELETE_ACCOMMODATION_MUTATION,
  },
  attributes: {
    ratioPackageNo: {
      name: 'ratioPackageNo',
      label: 'entities:ratioAccommodation.attributes.ratioPackageNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioAccommodation.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioAccommodation.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioAccommodation.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    isFamilyPackageAccommodation: {
      name: 'isFamilyPackageAccommodation',
      label: 'entities:ratioAccommodation.attributes.isFamilyPackageAccommodation.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    isBabyPackage: {
      name: 'isBabyPackage',
      label: 'entities:ratioAccommodation.attributes.isBabyPackage.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    capacitySettings: {
      name: 'capacitySettings',
      label: 'entities:ratioAccommodation.attributes.capacitySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return accommodationCapacitySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    addons: {
      name: 'addons',
      label: 'entities:ratioAccommodation.attributes.addons.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioAccommodationAddonEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioAccommodationModel
